import type { Post } from '@entities/post'
import { usePosts } from '@entities/post'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import type { FormProps } from 'antd'
import { Button, DatePicker, Form, Modal } from 'antd'
import type { Dayjs } from 'dayjs'
import { useCallback } from 'react'

interface SchedulePostModalProps {
    open: boolean
    onClose: () => void
    editPostData: Post
}

type FieldType = {
    publishDate: Dayjs
}

export const SchedulePostModal = ({ open, onClose, editPostData }: SchedulePostModalProps) => {
    const {
        actions: { schedulePost }
    } = usePosts()

    const [form] = Form.useForm()

    const onFinish: FormProps<FieldType>['onFinish'] = useCallback(
        async (values: FieldType) => {
            schedulePost({
                ...editPostData,
                state: 'planned',
                publishDate: values.publishDate.toDate()
            })

            onClose()
        },
        [schedulePost, editPostData, onClose]
    )

    const onSubmit = useCallback(
        (state?: Partial<FieldType>) => {
            if (state) {
                form.setFieldsValue({
                    ...state
                })
            }

            form.submit()
        },
        [form]
    )

    return (
        <Modal
            open={open}
            centered
            onCancel={onClose}
            title="Запланировать пост"
            footer={[
                <Button key="back" onClick={onClose}>
                    Отменить
                </Button>,
                <Button key="submit" type="primary" onClick={() => onSubmit()}>
                    Запланировать
                </Button>
            ]}
        >
            <Form
                form={form}
                name="add-post"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{ publishDate: dayjs(editPostData?.publishDate) }}
            >
                <Form.Item<FieldType>
                    label="Дата и время публикации"
                    name="publishDate"
                    required={false}
                    rules={[{ required: true, message: 'Обязательное поле' }]}
                >
                    <DatePicker
                        showTime
                        showSecond={false}
                        style={{ width: '100%' }}
                        format={['DD/MM/YYYY HH:mm', 'DD/MM/YY HH:mm', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm']}
                        minDate={dayjs()}
                        placeholder="Выберите дату публикации"
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}
